// src/App.js - VERSION LÉGÈRE POUR BOOKING PUBLIC
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './contexts/NotificationContext';
import PublicBooking from './pages/PublicBooking';
import ChatTest from './pages/ChatTest';

function App() {
  return (
    <NotificationProvider>
<Router basename={window.location.pathname.includes('/booking') ? '/booking' : ''}>
        <Routes>
          <Route path="/" element={<PublicBooking />} />
          <Route path="/chat-test" element={<ChatTest />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </NotificationProvider>
  );
}

export default App;
